import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";
import AnyColor from "@mapmycustomers/shared/types/AnyColor";
import { Company, EntityType, Person } from "@mapmycustomers/shared/types/entity";

import { RawTimelineEvent } from "@app/types/events/TimelineEvent";

import getTimelineEventEntityRef from "./getTimelineEventEntityRef";

// The legend-resolved color for the record a timeline card draws a marker for — the visited record of
// a check-in, or the created record of a record-added event. Undefined while its pin is still in
// flight, which is why the card also takes a loading flag.
const getEventPinColor = (
  event: RawTimelineEvent,
  accountPins: Record<Company["id"], Company & { shape?: MarkerShape }>,
  contactPins: Record<Person["id"], Person & { shape?: MarkerShape }>
): AnyColor | null | undefined => {
  const ref = getTimelineEventEntityRef(event);
  if (!ref) {
    return undefined;
  }
  const pin =
    ref.entityType === EntityType.COMPANY ? accountPins[ref.entityId] : contactPins[ref.entityId];
  return pin?.color;
};

export default getEventPinColor;
